import { create } from 'zustand';

export type TimOpenSource = 'manual' | 'email' | 'apppush';

export const parseTimOpenSource = (
  value?: string | null
): TimOpenSource => {
  if (value === 'manual' || value === 'email' || value === 'apppush') {
    return value;
  }
  return 'manual';
};

export const isTimAutoOpenSource = (source: TimOpenSource) =>
  source !== 'manual';

type OpenTimModalParams = {
  campaignId?: string | number | null;
  orderId?: string | number | null;
  source?: TimOpenSource;
};

type TimModalStore = {
  showTimModal: boolean;
  timUnreadCount: number;
  currentCampaignId: string;
  currentOrderId: string;
  openSource: TimOpenSource;
  /** 每次打开请求递增，用于把相同 order 的二次点击当作新命令 */
  openSeq: number;
  /** iframe 已完成首次初始化（iframe 已挂载，src 不含 token） */
  timLoaded: boolean;
  /** iframe src（裸 URL，token 通过 SET_STATE AUTH 发送） */
  timUrl: string;
  setShowTimModal: (show: boolean, params?: OpenTimModalParams) => void;
  setTimUnreadCount: (count: number) => void;
  /** 幂等：首次调用时写入 timUrl 并标记 timLoaded=true */
  setTimReady: (url: string) => void;
};

const toStoreValue = (value?: string | number | null) =>
  value == null ? '' : String(value);

export const useTimModalStore = create<TimModalStore>()((set) => ({
  showTimModal: false,
  timUnreadCount: 0,
  currentCampaignId: '',
  currentOrderId: '',
  openSource: 'manual',
  openSeq: 0,
  timLoaded: false,
  timUrl: '',
  setShowTimModal: (show, params) =>
    set((state) => ({
      showTimModal: show,
      currentCampaignId: show ? toStoreValue(params?.campaignId) : '',
      currentOrderId: show ? toStoreValue(params?.orderId) : '',
      openSource: show ? params?.source || 'manual' : state.openSource,
      openSeq: show ? state.openSeq + 1 : state.openSeq
    })),
  setTimUnreadCount: (count) => set({ timUnreadCount: count }),
  setTimReady: (url) =>
    set((state) => (state.timLoaded ? state : { timLoaded: true, timUrl: url }))
}));
